import { gql } from 'apollo-boost';

export const PLACE_FOLDER = gql`
    mutation($data: PlaceFolderInput!) {
        placeFolder(data: $data) {
            id
            title
            parent
            owner
            before
            isPinned
            pinnedRank
            deletedAt
        }
    }
`;
